import { UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import WarningIcon from '../../assets/icons/warning-outline.svg';
import { continueDemoBookingPressedAction } from '../../Bookings/actions';
import { Button, ButtonTypes } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import { getMemberShipPlansLink, openMembershipPlans } from '../../payments/utils';
import Theme from '../../theme';
import { LogoutHelper } from '../../utils';
import { defaultScale } from '../../utils/scaling';
import { CannotLaunchDemoBookingScreen } from '../reducers';

interface IProps {
  userProfile: UserProfile;
  t: (key: string, options?: any) => string;
  cannotLaunchDemoBookingScreen: CannotLaunchDemoBookingScreen;
  continueDemoBookingPressed: () => void;
  gymName?: string;
}

const CannotCreateDemoBooking: FunctionComponent<IProps> = (
  {
    userProfile,
    t,
    cannotLaunchDemoBookingScreen,
    continueDemoBookingPressed,
    gymName,
  }) => {
  const [loading, setLoading] = useState(false);

  const seeMembershipPlans = async () => {
    setLoading(true);
    await openMembershipPlans(userProfile, gymName);
  };

  const logOut = async () => {
    await LogoutHelper(getMemberShipPlansLink(userProfile, gymName));
  };

  if (cannotLaunchDemoBookingScreen === 'MAX_WORKOUTS_EXCEEDED') {
    return (
      <>
        <View style={styles.contentContainer}>
          <WarningIcon color={Theme.GREY} />
          <Text style={styles.heading}>{t('alreadyUsedFreeWorkout')}</Text>
          <Text style={styles.bodyContent}>{t('pleaseSelectProductToContinue')}</Text>
        </View>
        <Button title={t('dashboard:seeMembershipPlans')} onPress={seeMembershipPlans} fontColor={Theme.WHITE}
                isLoading={loading} containerStyle={{ marginBottom: defaultScale(10) }}/>
        <Button title={t('home:logout')} onPress={logOut}
                buttonType={ButtonTypes.TRANSPARENT} />
      </>
    );
  }

  return (
    <>
      <View style={styles.contentContainer}>
        <WarningIcon color={Theme.GREY} />
        <Text style={styles.heading}>{t('alreadySignedIn', { email: userProfile.email })}</Text>
      </View>
      <Button title={t('continueBooking')} onPress={continueDemoBookingPressed} fontColor={Theme.WHITE}
              containerStyle={{ marginBottom: defaultScale(10) }}/>
      <Button title={t('home:logout')} onPress={logOut}
              buttonType={ButtonTypes.TRANSPARENT} />
    </>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  heading: {
    ...Theme.textStyle.heading,
    textAlign: 'center',
    marginTop: defaultScale(30),
    marginBottom: defaultScale(20),
  },
  bodyContent: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
  },
});

const mapStateToProps = (state: IAppStore) => ({
  gymName: state.deepLinkParamaters.gymName,
});

const mapDispatchToProps = (dispatch, ownProps: IProps) => ({
  continueDemoBookingPressed: () => dispatch(continueDemoBookingPressedAction(ownProps.userProfile)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CannotCreateDemoBooking);
